import React, { useEffect } from 'react';
import { author, canonicalUrl, site } from '../data/site';
import { buildStructuredData } from '../utils/structuredData';
export function Seo() {
  useEffect(() => {
    document.documentElement.lang = 'en-GB';
    document.title = site.metaTitle;
    const metas: Array<[string, string, string]> = [['name', 'description', site.description], ['name', 'robots', 'index, follow, max-image-preview:large, max-snippet:-1'], ['name', 'author', author.name], ['name', 'theme-color', '#050816'], ['property', 'og:type', 'article'], ['property', 'og:locale', 'en_GB'], ['property', 'og:site_name', site.name], ['property', 'og:title', site.metaTitle], ['property', 'og:description', site.description], ['property', 'og:url', canonicalUrl], ['property', 'og:image', site.ogImage], ['property', 'og:image:alt', site.ogImageAlt], ['property', 'article:published_time', site.published], ['property', 'article:modified_time', site.modified], ['name', 'twitter:card', 'summary_large_image'], ['name', 'twitter:title', site.metaTitle], ['name', 'twitter:description', site.description], ['name', 'twitter:image', site.ogImage], ['name', 'twitter:image:alt', site.ogImageAlt]];
    metas.forEach(([attr, key, content]) => {
      let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    });
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;
  }, []);
  return <>
      {buildStructuredData().map(schema => <script key={schema['@type']} type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} data-id="element-213" data-mp="48x0z95giksu" />)}
    </>;
}